module.exports = __webpack_public_path__ + "d4b094ae1b229de39cd11c88ce1d441b.png";